
<div
	class="lineage-node-wrapper"
	:child="d.isChildNode"
	:type="d.type"
	:root="d.root"
	:style="styleObj"
	xmlns="http://www.w3.org/1999/xhtml"
>
	<Container :gap="4" :padding="0" align="left stretch" :grow="1">
		<div class="node-i-wrapper node-icon">
			<div class="node-icon-container">
				<Icon :name="d.icon ? d.icon : 'i-table'" type="filled" size="small" :effects="false" />
			</div>
		</div>
		<Container direction="column" align="left top" :gap="2" padding="0px 0px 0px 8px">
			<Container :gap="8" :padding="0">
				<div v-if="duplicateAlphabet" class="duplicate-indicator">
					{{ duplicateAlphabet }}
				</div>
				<Typography :type="d.isChildNode ? 'p2' : 'p1'" color="dark">
					{{ d.name }}
				</Typography>

				<div class="node-i-wrapper start">
					<div class="node-icon-container">
						<Icon v-if="d.state === 'verified'" size="small" name="i-tick-double" type="filled" />
					</div>
				</div>
			</Container>
			<Typography type="p2" :color="d.root ? 'default' : 'light'" overflow="ellipsis">
				{{ d.description }}
			</Typography>
		</Container>
		<Container
			v-if="d.features"
			:padding="0"
			:gap="12"
			align="right center"
			:grow="1"
			overflow="auto"
		>
			<div v-for="f in d.features" :key="f" class="node-i-wrapper start">
				<div class="node-icon-container">
					<Icon :name="f" type="filled" state="primary" size="20px" />
				</div>
			</div>
		</Container>
	</Container>
	<div class="node-i-wrapper end margin-lt-auto">
		<div class="node-icon-container">
			<Icon
				v-if="d.hasChildren"
				:name="d.childCollpsed ? 'i-chevron-down' : 'i-chevron-up'"
				class="toggle-child"
				type="filled"
				size="x-small"
				:effects="!d.root"
			/>
		</div>
	</div>
	<div class="node-info-wrapper">
		<div v-if="tag" class="node-i-wrapper start node-tag">
			<div class="node-icon-container">
				<Tag
					:size="tag.size ? tag.size : 'small'"
					:background="tag.background"
					:color="tag.color"
				>
					<Typography
						type="p3"
						weight="bold"
						transform="uppercase"
						:color="tag.color ? 'inherit' : 'black'"
					>
						{{ tag.text }}
					</Typography>
				</Tag>
			</div>
		</div>
		<div v-if="d.root" class="node-i-wrapper start">
			<div class="node-icon-container">
				<Icon name="i-location" type="filled" state="primary" :effects="false" />
			</div>
		</div>
		<div v-if="d.type === 'disabled'" class="node-i-wrapper start">
			<div class="node-icon-container" style="height: 16px">
				<Icon name="i-stop" type="filled" size="small" :effects="false" />
			</div>
		</div>
		<div v-if="subTag" class="node-i-wrapper end">
			<div class="node-icon-container">
				<Tag
					class="margin-lt-auto"
					:size="subTag.size ? subTag.size : 'small'"
					:background="subTag.background"
					:color="subTag.color"
				>
					<Typography
						type="p3"
						weight="bold"
						transform="uppercase"
						:color="subTag.color ? 'inherit' : 'black'"
					>
						{{ subTag.text }}
					</Typography>
				</Tag>
			</div>
		</div>
	</div>
</div>
